import { CHART_TYPE, CommonChartModel } from './chart.model';
import { TITLE_TYPE } from './dynamic-data-table.model';

const transferTooltip = function (this: any): string {
    const point = this.point ?? this;
    const row = point?.dataset ?? point?.custom ?? point?.options?.dataset ?? point?.options?.custom ?? point?.primaryData ?? point?.options?.primaryData ?? point?.options ?? {};
    return `<b>New Dealer:</b> ${row.newDealer ?? ''}<br/>` +
        `<b>Old Dealer:</b> ${row.oldDealer ?? ''}<br/>` +
        `<b>Transferred Associates Count:</b> ${row.totalAssocInBoth ?? 0}<br/>` +
        `<b>Total New Associate Count:</b> ${row.totalAssocInNewDealer ?? 0}<br/>` +
        `<b>Transfer Percentage:</b> ${row.transferPercentage ?? 0}%`;
};
const TransferPercentage = 'Transfer Percentage';

export const DealerTransferColumnChartSchema: CommonChartModel = {
    type: CHART_TYPE.ColumnChart,
    titleSchema: { label: '', title: 'Transfer Percentage by New Dealer - Column Chart', type: TITLE_TYPE.Static },
    xAxis: { type: 'category', categories: [], title: { text: 'Dealers' } },
    yAxis: { min: 0, max: 100, title: { text: TransferPercentage }, labels: { format: '{value}%' }, allowDecimals: false },
    series: [{ type: CHART_TYPE.ColumnChart, data: [], dataLabels: { enabled: false } }],
    dataSchema: { label: 'newDealer', value: 'transferPercentage' },
    dataLabels: { enabled: false },
    tooltip: { useHTML: true, formatter: transferTooltip },
    exportConfig: { fileName: 'Dealer_Transfer_Column' },
};

export const DealerTransferLineChartSchema: CommonChartModel = {
    type: CHART_TYPE.ColumnChart,
    isLineChart: true,
    titleSchema: { label: '', title: 'Transfer Percentage by New Dealer - Line Chart', type: TITLE_TYPE.Static },
    xAxis: { type: 'category', categories: [], title: { text: 'Dealers' } },
    yAxis: { min: 0, max: 100, title: { text: TransferPercentage }, labels: { format: '{value}%' }, allowDecimals: false },
    series: [{ type: 'line' as any, data: [], dataLabels: { enabled: false } }],
    dataSchema: { label: 'newDealer', value: 'transferPercentage' },
    dataLabels: { enabled: false },
    tooltip: { useHTML: true, formatter: transferTooltip },
    exportConfig: { fileName: 'Dealer_Transfer_Line' },
};


export const DealerTransferWaveChartSchema: CommonChartModel = {
    type: CHART_TYPE.AreasplineChart,
    titleSchema: { label: '', title: 'Transfer Percentage by New Dealer - Wave Chart', type: TITLE_TYPE.Static },
    xAxis: { type: 'category', categories: [], title: { text: 'Dealers' } },
    yAxis: { min: 0, max: 100, title: { text: TransferPercentage }, labels: { format: '{value}%' }, allowDecimals: false },
    series: [{ type: CHART_TYPE.AreasplineChart, data: [] }],
    dataSchema: { label: 'newDealer', value: 'transferPercentage' },
    dataLabels: { enabled: false },
    tooltip: { useHTML: true, formatter: transferTooltip },
    exportConfig: { fileName: 'Dealer_Transfer_Wave' },
};

export const DealerTransferDistributionChartSchema: CommonChartModel = {
    type: CHART_TYPE.ColumnChart,
    titleSchema: { label: '', title: 'Transfer Percentage Distribution', type: TITLE_TYPE.Static },
    xAxis: { type: 'category', categories: [], title: { text: TransferPercentage } },
    yAxis: { min: 0, title: { text: 'Count' }, allowDecimals: false },
    series: [{ type: CHART_TYPE.ColumnChart, data: [] }],
    dataSchema: {
        label: 'band',
        value: 'count',
        drillDownConfig: {
            drillDownField: 'dealerDetails',
            label: 'dealer',
            value: 'totalAssocInOldDealer',
            type: CHART_TYPE.BarChart,
            tooltip: { useHTML: true, formatter: transferTooltip },
            xAxis: { type: 'category', title: 'Dealers' as any },
            yAxis: { min: 0, title: 'Transfer Associate Count' as any, labels: { format: '{value}' } },
        },
    },
    drilldown: {
        breadcrumbs: { position: { align: 'right' } },
        series: [],
    },
    tooltip: { useHTML: false },
    exportConfig: { fileName: 'Dealer_Transfer_Distribution' },
};

export const DealerTransferBarChartSchema: CommonChartModel = {
    type: CHART_TYPE.BarChart,
    titleSchema: { label: '', title: 'Transfer Percentage by New Dealer - Bar Chart', type: TITLE_TYPE.Static },
    xAxis: { min: 0, max: 100, tickInterval: 10, title: { text: TransferPercentage }, labels: { format: '{value}%' } },
    yAxis: { type: 'category', title: { text: 'New Dealer' } },
    series: [{ type: CHART_TYPE.BarChart, data: [] }],
    dataSchema: {
        label: 'newDealer',
        value: 'transferPercentage',
        drillDownConfig: {
            drillDownField: 'dealerDetails',
            label: 'dealer',
            value: 'totalAssocInOldDealer',
            type: CHART_TYPE.ColumnChart,
            tooltip: { useHTML: true, formatter: transferTooltip },
            xAxis: { type: 'category', title: { text: 'Dealers' } },
            yAxis: { min: 0, title: { text: 'Transfer Associate Count' }, allowDecimals: false },
        },
    },
    drilldown: {
        breadcrumbs: { position: { align: 'right' } },
        series: [],
    },
    tooltip: { useHTML: true, formatter: transferTooltip },
    exportConfig: { fileName: 'Dealer_Transfer_Bar' },
};

export const DealerTransferBandsChartSchema: CommonChartModel = {
    type: CHART_TYPE.PieChart,
    isPie: true,
    titleSchema: { label: '', title: 'Dealer Transfer Bands', type: TITLE_TYPE.Static },
    series: [{ type: CHART_TYPE.PieChart, data: [] }],
    dataSchema: {
        label: 'band',
        value: 'count',
        drillDownConfig: {
            drillDownField: 'dealerDetails',
            label: 'dealer',
            value: 'totalAssocInBoth',
            type: CHART_TYPE.BarChart,
            tooltip: { useHTML: true, formatter: transferTooltip },
            xAxis: { type: 'category', title: 'Dealers' as any },
            yAxis: { min: 0, title: 'Transfer Associate Count' as any, labels: { format: '{value}' } },
        },
    },
    drilldown: {
        breadcrumbs: { position: { align: 'right' } },
        series: [],
    },
    tooltip: { useHTML: false },
    exportConfig: { fileName: 'Dealer_Transfer_Bands' },
};

export const DealerNewAssociatesChartSchema: CommonChartModel = {
    type: CHART_TYPE.ColumnChart,
    titleSchema: { label: '', title: 'New Associates by Dealer', type: TITLE_TYPE.Static },
    xAxis: { type: 'category', categories: [], title: { text: 'New Dealer' } },
    yAxis: { min: 0, title: { text: 'New Associates Count' }, allowDecimals: false },
    series: [{ type: CHART_TYPE.ColumnChart, data: [] }],
    dataSchema: { label: 'dealer', value: 'newAssociates' },
    exportConfig: { fileName: 'Dealer_New_Associates' },
};
